<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { PrimaryButton, OverlayView, DividerComponent, AllowedRoundedSize } from '@hfc/ui-core';
import { PlanFilter } from '@/application/smallBusiness/domain/SmallBusinessPlanFilters';
import SmallBusinessPlanFiltersMobile from '@/application/smallBusiness/infrastructure/components/SmallBusinessPlanFiltersMobile.vue';
import CalChoiceToggle from '@/application/smallBusiness/infrastructure/components/CalChoiceToggle.vue';
import SampleEmployeeDetails from '@/application/smallBusiness/infrastructure/components/SampleEmployeeDetails.vue';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessStore, smallBusinessState } = useSmallBusinessStore();

const overlayOpen = ref<boolean>(false);
const localFilters = ref<Array<PlanFilter>>([]);

const availableFilters = computed(() => smallBusinessState.value.availableFilters as Array<PlanFilter>);

const updateFilterPlans = (filters: Array<PlanFilter>): void => {
  localFilters.value = filters;
};

const updateFilters = async (): Promise<void> => {
  overlayOpen.value = false;
  smallBusinessStore.setFilters(localFilters.value);
  await smallBusinessStore.fetchAvailablePlans();
};

onMounted(async () => {
  await smallBusinessStore.fetchAvailablePlans();
});
</script>
<template>
  <OverlayView class="flex xl:hidden bg-white z-[901]" title="Selected Filters" v-model:is-open="overlayOpen" :self-trigger="true" icon="filter" close-icon="arrow-right"  @close="overlayOpen = false">
    <div v-if="overlayOpen" class="flex h-full flex-col items-center space-y-6 py-4">
      <SampleEmployeeDetails :horizontal-layout="true" />
      <DividerComponent />
      <SmallBusinessPlanFiltersMobile v-if="!smallBusinessState.availablePlansLoading && availableFilters.length > 0" :filters="availableFilters" @update-values="updateFilterPlans"/>
      <DividerComponent />
      <CalChoiceToggle class="w-full" />
      <div class="flex flex-grow w-full items-end justify-end">
        <PrimaryButton :is-loading="smallBusinessState.availablePlansLoading" @click="updateFilters" :rounded="AllowedRoundedSize.BASIC">
          Update
        </PrimaryButton>
      </div>
    </div>
  </OverlayView>
</template>
